/**
 * Device types configuration
 * Defines all device types supported by the system
 */
export const DEVICE_TYPES_CONFIG = [
  {
    id: 1,
    type: 'LIMA',
    hasSource: 1
  },
  {
    id: 2,
    type: 'Log Forwarder',
    hasSource: 1
  },
  {
    id: 3,
    type: 'Sensor',
    hasSource: 0
  },
  {
    id: 4,
    type: 'EDR',
    hasSource: 0
  },
  {
    id: 5,
    type: 'VMP',
    hasSource: 0
  }
];

/**
 * Device type ID for LIMA devices
 */
export const DEVICE_TYPE_LIMA = 1;

export default DEVICE_TYPES_CONFIG;
